import { FormattedMessage } from 'react-intl'

import { CircularProgress } from './CircularProgress'
import { Grid } from './Grid'
import { Typography } from './Typography'

export function PageLoadingView() {
  return (
    <Grid className="page-loading-container" container justifyContent="center" alignItems="center">
      <Grid item style={{ textAlign: 'center' }}>
        <div>
          <div style={{ marginBottom: 30 }}>
            <CircularProgress size={50} />
          </div>
          <Typography size="400-md">
            <FormattedMessage id="pages.loadingPage.title" defaultMessage="Oldal betöltése folyamatban..." />
          </Typography>
        </div>
      </Grid>
    </Grid>
  )
}
